export const SET_PROFILE = 'SET_PROFILE'
export const UPDATE_EXPENSE_KEY = 'UPDATE_EXPENSE_KEY'
export const UPDATE_EXPENSE = 'UPDATE_EXPENSE'
export const ADD_EXPENSE = 'ADD_EXPENSE'
export const DELETE_EXPENSE = 'DELETE_EXPENSE'